<template>
  <Highcharts
    ref="chart"
    :options="chartOptions"
  />
</template>

<script>
import Highcharts from 'highcharts';
import More from 'highcharts/highcharts-more';
import { Chart } from 'highcharts-vue';

import { formattedTooltip } from './formatter-tooltip';

More(Highcharts);

export default {
  name: 'PackedBubble',
  components: {
    Highcharts: Chart,
  },
  props: {
    series: {
      type: Array,
      required: true,
    },
    overrideChartOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    chartOptions() {
      const series = this.series;

      return {
        chart: {
          type: 'packedbubble',
          styleMode: true,
          borderRadius: 0,
          spacingBottom: 3,
          spacingLeft: 0,
          spacingRight: 1,
          height: 590,
        },
        legend: {
          symbolHeight: 8,
          symbolWidth: 8,
          symbolRadius: 10,
          squareSymbol: false,
          align: 'left',
          margin: 16,
          padding: 5,
          itemStyle: {
            fontWeight: 600,
          },
        },
        title: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          shared: false,
          useHTML: true,
          shadow: false,
          backgroundColor: 0,
          borderWidth: 0,
          borderRadius: 0,
          formatter() {
            return formattedTooltip(this);
          },
        },
        exporting: {
          enabled: false,
          sourceWidth: 1250,
          chartOptions: {
            chart: {
              marginRight: 50,
              styleMode: true,
              borderRadius: 0,
              plotBorderWidth: 1,
              spacingBottom: 3,
              spacingLeft: 0,
              spacingRight: 1,
              height: 550,
            },
          },
        },
        plotOptions: {
          packedbubble: {
            minSize: '15%',
            maxSize: '100%',
            layoutAlgorithm: {
              bubblePadding: 8,
              splitSeries: true,
              enableSimulation: true,
              parentNodeLimit: true,
              seriesInteraction: false,
              parentNodeOptions: {
                bubblePadding: 50,
                marker: {
                  fillOpacity: 0.5,
                },
              },
            },
            dataLabels: {
              enabled: true,
              format: '{point.name}',
              style: {
                color: 'black',
                textOutline: 'none',
                fontWeight: 'normal',
              },
            },
          },
          series: {
            events: {
              legendItemClick: (e) => {
                this.$emit('legend-click', { legend: e.target.name });
              },
            },
          },
        },
        series,
        ...this.overrideChartOptions,
      };
    },
  },
};
</script>
